import styled from "@emotion/styled";

export const ZoomSliderWrapper = styled.div`
  display: flex;
  align-items: center; /* for items-center */
  gap: 0.5rem; /* for gap-2 (Tailwind's gap-2 is 0.5rem) */
`;

export const Button = styled.button`
  border: none;
  background: none;
  padding: 0px;
  font-size: 18px;
  color: #2f8de4;
  cursor: pointer;
  font-size: 20px;
`;

export const RangeContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 100px;
  height: 30px;
  display: flex;
  align-items: center;
`;

export const RangeTrack = styled.div<{
  value: number;
  min: number;
  max: number;
}>`
  position: absolute;
  width: 100%;
  height: 6px;
  background-color: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    height: 100%;
    width: ${(props) =>
      ((props.value - props.min) / (props.max - props.min)) * 100}%;
    background-color: #2f8de4;
    border-radius: 4px;
  }
`;

export const Input = styled.input`
  -webkit-appearance: none;
  appearance: none;
  width: 100%;
  height: 8px;
  background: transparent; /* Make the actual input transparent */
  position: relative;
  z-index: 2;
  margin: 0;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 14px;
    width: 14px;
    border-radius: 50%;
    background: #2f8de4;
    cursor: pointer;
    border: none;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 3;
  }

  &::-moz-range-thumb {
    height: 14px;
    width: 14px;
    border-radius: 50%;
    background: #2f8de4;
    cursor: pointer;
    border: none;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 3;
  }

  &:focus {
    outline: none;
  }
`;
